import { render, staticRenderFns } from "./action-link-tab.vue?vue&type=template&id=efe6926e"
import script from "./action-link-tab.vue?vue&type=script&lang=js"
export * from "./action-link-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports